"use strict";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import axios from "axios";
import { PDFDocument } from 'pdf-lib';
import docxToPdf from 'docx-to-pdf';
import { cerrarSesion } from "../utilities/Seguridad";
//const libre = require('libreoffice-convert');

const templante = [];
templante[1] = "FU_REVALUACION_TEL_2012.docx";
templante[2] = "FU_REVALUACION_TEL_2012.docx";
templante[3] = "TDA_20121.docx";
templante[4] = "DEA_2012.docx";
templante[5] = "FIL_-2012-1.docx";

templante[6] = "DISCAPACIDAD_INTELECTUAL_NEEP_-2012-1.docx";
templante[7] = "DISCAPACIDAD_INTELECTUAL_NEEP_-2012-1.docx";
templante[8] = "DISCAPACIDAD_INTELECTUAL_NEEP_-2012-1.docx";
templante[9] = "TEA_2012-1.docx";
templante[10] = "DISCAPACIDAD_VISUAL_2012-1.docx";
templante[11] = "DISCAPACIDAD_AUDITIVA_2012-1.docx";
templante[12] = "DISCAPACIDAD-MULTIPLE.docx";
templante[13] = "DISFASIA-SEVERA_2012-1.docx";
templante[14] = "DISCAPACIDAD-MOTORA_2012-1.docx";

templante["anamnesis"] = "ANAMNESIS.docx";
templante["autorizacion"] = "AUTORIZACION_EVALUACION.docx";
templante["evaluacion_psicopedagogica_curricular"] = "EVALUACION_PSICOPEDAGOGICA_Y_CURRICULAR.docx";
templante["informe_familia"] = "INFORME_PARA_LA_FAMILIA.docx";
templante["interconsulta"] = "INTERCONSULTA.docx";
templante["valoracion_salud"] = "VALORACION_DE_SALUD.docx";

function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}

export function generateDocument(id, data, urlAdjunto = null) {

  if (urlAdjunto === null) {
    let word = templante[id];
    loadFile(`${process.env.REACT_APP_URL}/templates/${id}/${word}`, function (error, content) {
      if (error) {
        console.log(error);
      }
      const zip = new PizZip(content);
      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });

      // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
      doc.render(data);
      const out = doc.getZip().generate({
        type: "blob", //blob
        mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      }); //Output the document using Data-URI

      const file = new File([out], "output.docx", { type: doc.type });
      saveAs(file, word);
    });

  } else {
    donwloadDocumentoAdjunto(urlAdjunto);
  }

}

export async function donwloadDocumentoAdjunto(urlAdjunto) {
  if (urlAdjunto == "") return
  var parts = urlAdjunto.split("/");
  var lastSegment = parts.pop() || parts.pop();

  let config = {
    method: "get",
    url: urlAdjunto,
    responseType: "blob",
  };

  const response = await axios(config)
    .then((response) => {
      let url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", lastSegment);
      document.body.appendChild(link);
      link.click();
      return true;
    })
    .catch((error) => {
      console.log(error);
      return false;
    });
  return response;
}


export const generateDocumentMasivo = async (documento) => {
  try {
    // Recorrer cada formulario desde la API
    await Promise.all([
      donwloadDocumentoAdjunto(documento.nombre_word),
      donwloadDocumentoAdjunto(documento.nombre_pdf)
    ]);

    console.log("Todos los documentos han sido descargados");
  } catch (error) {
    console.error("Error descargando los documentos:", error);
  }
};
